import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NavItem } from '@app/interfaces/nav-item';
import { NavComponent } from '@app/layout/nav/nav.component';
import { environment } from '@envs/environment';

@Component({
  selector: 'app-terms-of-use-page',
  templateUrl: './terms-of-use.page.html',
  styleUrls: ['./terms-of-use.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, NavComponent],
})
export class TermsOfUsePage {
  protected environment = environment;

  protected navItems: NavItem[] = [{ label: 'Terms of use' }];
}
